<div class="page-container">
  <div class="header-section">
    <div class="title-block">
      <h1>{{ articleType?.databaseId && articleType!.databaseId > 0 ? 'Edit Article Type' : 'Create New Article Type' }}
      </h1>
    </div>

    <div class="header-actions">
      <button class="btn-secondary" (click)="openCancelDialog()">
        <span class="material-icons">arrow_back</span> Back
      </button>
      <button class="btn-primary" (click)="saveArticleType()"
        [disabled]="!articleType?.english || !articleType?.german">
        <span class="material-icons">save</span> Save
      </button>
    </div>
  </div>

  <div class="form-card" *ngIf="articleType">
    <div class="form-grid-layout">

      <div class="form-group">
        <label class="form-label">English Title <span class="required">*</span></label>
        <input pInputText [(ngModel)]="articleType.english" name="english"
          placeholder="Enter English title" />
      </div>

      <div class="form-group">
        <label class="form-label">German Title <span class="required">*</span></label>
        <input pInputText [(ngModel)]="articleType.german" name="german" placeholder="Enter German title" />
      </div>

      <div class="form-group full-width mt-3">
        <div class="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 class="card-title">Article Type Images</h3>
          <div class="upload-controls">
            <input type="file" accept="image/*" multiple (change)="onImageSelected($event)" hidden #imageInput />
            <button type="button" class="card-action-btn" (click)="imageInput.click()" [disabled]="isUploading">
              <span class="material-icons">upload_file</span> Add Images
            </button>
            <button *ngIf="pendingImages.length > 0" type="button" class="card-action-btn btn-delete"
              (click)="clearPendingImages(imageInput)" [disabled]="isUploading">
              <span class="material-icons">delete_outline</span> Clear Pending
            </button>
          </div>
        </div>

        <div class="image-gallery" *ngIf="(articleType.images?.length || 0) > 0 || pendingImages.length > 0; else noImages">
          <div class="image-tile" *ngFor="let image of articleType.images">
            <div class="image-tile__media">
              <img [src]="image.imageUrl" alt="Article type image" />
              <span class="image-primary-badge" *ngIf="image.isPrimary">Primary</span>
            </div>
            <div class="image-tile__actions">
              <button type="button" class="icon-action" (click)="setPrimaryImage(image)"
                [disabled]="image.isPrimary || isUploading" title="Set as primary">
                <span class="material-icons">star</span>
              </button>
              <button type="button" class="icon-action icon-action--danger" (click)="deleteImage(image)"
                [disabled]="isUploading" title="Remove image">
                <span class="material-icons">delete_outline</span>
              </button>
            </div>
          </div>

          <div class="image-tile image-tile--pending" *ngFor="let image of pendingImages; let i = index">
            <div class="image-tile__media">
              <img [src]="image.previewUrl" alt="Pending article type image" />
              <span class="image-primary-badge">Pending</span>
            </div>
            <div class="image-tile__actions">
              <button type="button" class="icon-action icon-action--danger" (click)="removePendingImage(i)"
                [disabled]="isUploading" title="Remove pending image">
                <span class="material-icons">delete_outline</span>
              </button>
            </div>
          </div>
        </div>

        <ng-template #noImages>
          <div class="empty-image-state">
            <span class="material-icons">image</span>
            <span>No images selected</span>
          </div>
        </ng-template>

        <div class="file-info mt-2">
          <ng-container *ngIf="isUploading">Uploading...</ng-container>
          <ng-container *ngIf="!isUploading">
            {{ articleType.images.length + pendingImages.length }} image(s)
          </ng-container>
        </div>
      </div>


      <div class="form-group full-width mt-4">
        <div class="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 class="card-title">Points of Measurement</h3>
          <button class="card-action-btn" (click)="addHandler()">
            <span class="material-icons">add</span> Add Point
          </button>
        </div>

        <div class="grid-container-scroll">
          <p-table [value]="pointOfMeasurements" [paginator]="true" [rows]="gridState.take ?? 10" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>PoM EN</th>
                <th>PoM DE</th>
                <th style="width: 120px">Tol. +</th>
                <th style="width: 120px">Tol. -</th>
                <th style="width: 90px">Control</th>
                <th style="width: 90px">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dataItem>
              <tr>
                <td><input pInputText [(ngModel)]="dataItem.titleEn" placeholder="English" /></td>
                <td><input pInputText [(ngModel)]="dataItem.titleDe" placeholder="German" /></td>
                <td>
                  <p-inputNumber [(ngModel)]="dataItem.tolerancePlus" [step]="0.1" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
                </td>
                <td>
                  <p-inputNumber [(ngModel)]="dataItem.toleranceMinus" [step]="0.1" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
                </td>
                <td>
                  <div class="d-flex justify-content-center">
                    <input type="checkbox" [(ngModel)]="dataItem.controlMeasure"
                      style="accent-color: var(--labtech-teal); width: 18px; height: 18px;" />
                  </div>
                </td>
                <td>
                  <button class="btn-delete" (click)="removeHandler(dataItem)" style="border:none; background:none;">
                    <span class="material-icons" style="color: var(--labtech-status-error)">delete_outline</span>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-container *ngIf="cancelDialog">
  <p-dialog [modal]="true" [visible]="true" header="Please Confirm" (onHide)="toggleCancelDialog()" [style]="{ width: '450px' }">
    <p style="margin: 30px; font-weight: 500; text-align: center;">
      Are you sure you want to discard the changes?
    </p>
    <ng-template pTemplate="footer">
      <button class="btn-secondary" (click)="toggleCancelDialog()">No</button>
      <button class="btn-primary" (click)="cancelHandler()">Yes</button>
    </ng-template>
  </p-dialog>
</ng-container>
